import { render, staticRenderFns } from "./DatasetDistributionGroup.vue?vue&type=template&id=1e4b0bb2&scoped=true&"
import script from "./DatasetDistributionGroup.vue?vue&type=script&lang=js&"
export * from "./DatasetDistributionGroup.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDistributionGroup.vue?vue&type=style&index=0&id=1e4b0bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b0bb2",
  null
  
)

export default component.exports